
<button class="boxed-btn2-small"  (click)="handleClickEvent($event)"  type="submit" i18n>Send Money</button>


